import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimWorkOrderPriceMtrDistributionInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimUpdateWorkOrderPriceMTRDistributionGql } from '../../bimWorkOrderQueries';

const requestId = 'bimUpdateWorkOrderPriceMTRDistribution';

export const useBimUpdateWorkOrderPriceMTRDistribution = (workOrderPriceId: number, onSuccess: () => void) => {
    const dispatch = useDispatch();
    const [resetUpdateData] = useResetStoreData({ requestId });

    const [
        bimUpdateWorkOrderPriceMTRDistributionData,
        bimUpdateWorkOrderPriceMTRDistributionStatus,
        bimUpdateWorkOrderPriceMTRDistributionError,
        bimUpdateWorkOrderPriceMTRDistributionRequest,
    ] = useRequest({
        requestId,
        query: bimUpdateWorkOrderPriceMTRDistributionGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const bimUpdateWorkOrderPriceMTRDistributionMakeRequest = useCallback(
        (input: BimWorkOrderPriceMtrDistributionInput) => {
            resetUpdateData(undefined);
            dispatch(bimUpdateWorkOrderPriceMTRDistributionRequest({ workOrderPriceId, input }));
        },
        [bimUpdateWorkOrderPriceMTRDistributionRequest, resetUpdateData, dispatch, workOrderPriceId],
    );

    const bimUpdateWorkOrderPriceMTRDistributionReset = useCallback(() => {
        resetUpdateData(undefined);
    }, [resetUpdateData]);

    useEffect(() => {
        resetUpdateData(undefined);
    }, [resetUpdateData]);

    return {
        bimUpdateWorkOrderPriceMTRDistributionReset,
        bimUpdateWorkOrderPriceMTRDistributionData,
        bimUpdateWorkOrderPriceMTRDistributionStatus,
        bimUpdateWorkOrderPriceMTRDistributionError,
        bimUpdateWorkOrderPriceMTRDistributionMakeRequest,
        bimUpdateWorkOrderPriceMTRDistributionRequest,
    };
};
